import { useSelector } from "react-redux";

import useShiftTimes from "../Hooks/useShiftTimes";
import { DashboardCard } from "./DashboardCard";
import { HourlyMetricsCard } from "./DashboardCards/HourlyMetricsCard";
import { ImportChecksCard } from "./DashboardCards/ImportChecksCard";
import { MaterialMovementCard } from "./DashboardCards/MaterialMovementCard";
import { PlantStatusCard } from "./DashboardCards/PlantStatusCard";
import useShiftLockInfo from "../Hooks/useShiftLockInfo";
import { RootState } from "../../state/store";
import { hasTile } from "../../utilities/helpers/roleUtilities";

export const DashboardGrid: React.FC = () => {
  const { selectedDate, selectedShift } = useShiftTimes();
  const { shiftLockState } = useShiftLockInfo(selectedDate, selectedShift);
  const { user } = useSelector((s: RootState) => s.authReducer);

  return (
    <div className="w-full grid gap-6 xl:gap-8 grid-cols-12 justify-items-center justify-center">
      {hasTile(user, "material-movement") && (
        <DashboardCard
          key="material-movement-card"
          title="Material Movement"
          linkTo="/production/show"
          linkTooltip="Open Production"
          linkArea="production/show"
          colSpan={{ base: 12, "xl": 6 }}
        >
          <MaterialMovementCard shiftLockState={shiftLockState} />
        </DashboardCard>
      )}
      {hasTile(user, "plant-status") && (
        <DashboardCard
          key="plant-status-card"
          title="Plant Status"
          linkTo="/stoppages"
          linkTooltip="Open Stoppages"
          linkArea="stoppages"
          colSpan={{ base: 12, "xl": 6 }}
        >
          <PlantStatusCard shiftLockState={shiftLockState} />
        </DashboardCard>
      )}
      {hasTile(user, "import-checks") && (
        <DashboardCard
          key="import-checks-card"
          title="Import Checks"
          linkTo="/operations"
          linkTooltip="Open Operations"
          linkArea="operations"
          colSpan={{ base: 12, "xl": 6 }}
          heightClass="h-[350px]"
          minHeightClass="min-h-[220px]"
        >
          <ImportChecksCard />
        </DashboardCard>
      )}
      {hasTile(user, "hourly-metrics") && (
        <DashboardCard
          key="hourly-metrics-card"
          title="Hourly Metrics"
          linkTo="/reports/daily"
          linkTooltip="Open Daily Report"
          linkArea="reports/daily"
          colSpan={{ base: 12 }}
        >
          <HourlyMetricsCard shiftLockState={shiftLockState} />
        </DashboardCard>
      )}
    </div>
  );
};